<template>
    <div class="payment-cell">
        <span v-if="loading" role="status">Загрузка…</span>
        <template v-for="row in rows">
            <PayrollMoneyInput :key="`amount-${row.id}`" v-model="row.amount" size="sm" :disabled="busy" :aria-label="`Фактически выплачено: ${row.name}`" @keydown.native.enter.prevent="save" />
            <small :key="`delta-${row.id}`" aria-live="polite">{{ difference(delta(row), row.currency) }}</small>
            <AppTextarea :key="`comment-${row.id}`" v-model="row.comment" class="form-control form-control-sm" :disabled="busy" :placeholder="correcting ? 'Причина исправления — обязательно' : 'Комментарий — необязательно'" :aria-label="correcting ? 'Причина исправления' : 'Комментарий к выплате'" maxlength="4000" />
        </template>
        <div v-if="error" class="payment-cell__error" role="alert">{{ error }} <button v-if="!rows.length" type="button" class="btn btn-sm btn-outline-danger" @click="load">Повторить</button></div>
        <div class="payment-cell__actions">
            <div v-if="blockedReason" class="payment-cell__error" role="alert">{{ blockedReason }}</div>
            <button v-if="rows.length" type="button" class="btn btn-primary btn-sm" :disabled="busy || !!blockedReason" @click="save">{{ busy ? 'Сохраняем…' : correcting ? 'Сохранить' : 'Выплачено' }}</button>
            <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="busy" @click="requestClose">Отмена</button>
        </div>
    </div>
</template>
<script>
import paymentForm from './payrollPaymentForm';
import PayrollMoneyInput from './PayrollMoneyInput.vue';
export default {
    ...paymentForm, name: 'PayrollPaymentCell', components: {PayrollMoneyInput},
    mounted() { this.focusAmount(); },
    methods: {
        focusAmount() { this.$nextTick(() => { const input = this.$el && this.$el.querySelector('input'); if (input) input.focus({preventScroll: true}); }); },
        ...paymentForm.methods,
        async load() {
            await paymentForm.methods.load.call(this);
            if (this.details && this.details.can_correct) { this.beginCorrection(); this.focusAmount(); }
            else if (this.details) this.error = 'Исправление этой выплаты недоступно.';
        }
    }
};
</script>
<style scoped>
.payment-cell {min-width: 180px; max-width: 300px; display: grid; gap: 6px;}
.payment-cell small {color: #374151;}
.payment-cell__actions {display: flex; flex-wrap: wrap; gap: 6px;}
.payment-cell__error {padding: 6px; color: #842029; background: #f8d7da; border: 1px solid #f1aeb5; border-radius: 4px;}
@media (max-width: 700px) {.payment-cell {min-width: 0; max-width: none;}}
</style>
